import { Space } from 'antd';
import { NavLink } from "react-router-dom";
import PageSection from '../page-section';
import './index.css';

function PageSectionNav({ items }) {

  return (
    items?.length > 0 &&
    <nav aria-label='Content navigation' className="bccampus-page-section-nav">
      <PageSection padding="horizontal">
        <Space size={24} align="stretch">
          {
            items.map(item => {
              if (!item) return null;

              const hash = `#${item.hash}`;
              return (
                <NavLink key={item.hash} to={location => ({ ...location, hash: hash })} replace
                  isActive={(match, location) => {
                    if (!match) return false;
                    return location.hash === hash;
                  }}
                >
                  {item.title}
                </NavLink>
              )
            })
          }
        </Space>
      </PageSection>
    </nav>
  )
}

export default PageSectionNav;
